import { useAuth } from '../context/AuthContext';
import { useEnvironment } from '../context/EnvironmentContext';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, error, login } = useAuth();
  const { envName, isProduction } = useEnvironment();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-deep-navy">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-cloud-white/30 border-b-cloud-white" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-deep-navy via-[#1B263B] to-storm-blue p-4">
        <section className="w-full max-w-md rounded-[20px] bg-cloud-white p-8 text-center shadow-2xl">
          <img src="/logos/Flock_Icon.svg" alt="Flock" className="mx-auto mb-4 h-20" />
          <h1 className="text-2xl font-bold text-deep-navy">The Fold</h1>
          <p className="mt-1 text-sm text-storm-blue">Flock Operations · {envName}</p>
          {isProduction && (
            <p className="mt-4 rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-800">
              This portal is connected to production.
            </p>
          )}
          {error && (
            <p role="alert" className="mt-4 rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">
              {error}
            </p>
          )}
          <button
            type="button"
            onClick={login}
            className="mt-6 min-h-[48px] w-full rounded-xl bg-deep-navy px-6 py-3 text-[16px] font-semibold text-white shadow-md transition hover:bg-[#1B263B] focus:outline-none focus-visible:ring-2 focus-visible:ring-storm-blue focus-visible:ring-offset-2"
          >
            Continue with Google
          </button>
          <p className="mt-4 text-xs text-storm-blue">
            Access is limited to Google accounts approved by a Fold owner.
          </p>
        </section>
      </main>
    );
  }

  return children;
}
